import { IconProps } from "./";
import Icon from "./assets/clock_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Clock(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
